import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift, ArrowRight } from 'lucide-react';
export function IncludesSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-stone-50 overflow-hidden" data-id="element-266">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        {/* Intro Block */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="max-w-3xl mx-auto text-center mb-20" data-id="element-268">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-8" data-id="element-269">
            Lo que viene incluido{' '}
            <span className="text-emerald-600" data-id="element-270">(sin costo extra)</span>
          </h2>
          <div className="space-y-4 text-lg text-stone-700 text-left md:text-center bg-white p-8 rounded-2xl shadow-sm border border-stone-100" data-id="element-271">
            <p className="font-semibold text-xl text-stone-900" data-id="element-272">
              Pero eso no es todo.
            </p>
            <p data-id="element-273">
              Cuando decidís empezar tu Rutina Vital hoy, no solo recibís el
              Protocolo Anti-Inflamación de 30 días.
            </p>
            <p data-id="element-274">
              Agregamos diseñados para que no te quedes trabado en ningún punto
              del camino.
            </p>
            <p data-id="element-275">
              Porque la diferencia entre alguien que ve resultados y alguien que
              abandona en la semana 2 no es la información.
            </p>
            <p className="font-semibold text-emerald-700 bg-emerald-50 inline-block px-4 py-2 rounded-lg mt-2" data-id="element-276">
              Es el soporte práctico que recibe mientras implementa.
            </p>
          </div>
        </motion.div>

        {/* Bonuses — compact grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20" data-id="element-277">
          {[{
          n: '1',
          title: 'Menú Anti-Inflamación Express',
          tag: '(15 Min)',
          summary: '21 comidas listas en 15 minutos o menos, con ingredientes reales del súper argentino. Para que nunca te quedes sin saber qué cocinar.',
          img: 'https://cdn.magicpatterns.com/uploads/fVajTvTLYnhuq2oZ12f8QZ/BONO_1.png',
          alt: 'Menú Anti-Inflamación Express'
        }, {
          n: '2',
          title: 'Tracker "Abdomen Calmado"',
          tag: '(7 Días)',
          summary: 'En 7 días y 3 minutos al día, descubrís qué dispara tu inflamación y exactamente qué cambiar primero. Sin apps ni cálculos.',
          img: 'https://cdn.magicpatterns.com/uploads/mnyYNj5m9ys9XyBo8NQA2s/BONO_2.png',
          alt: 'Tracker Abdomen Calmado'
        }, {
          n: '3',
          title: 'Guía "Café Sin Inflamar"',
          tag: '(5 Reglas)',
          summary: '5 reglas claras para que el café deje de inflamarte y pase a ser una herramienta. Sin dejarlo y sin elegir entre energía o abdomen liviano.',
          img: 'https://cdn.magicpatterns.com/uploads/taAKcPt8F8JyLYcfVBuHNn/BONO_3.png',
          alt: 'Guía Café Sin Inflamar'
        }].map((bono, i) => <motion.div key={bono.n} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} variants={fadeIn} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-stone-200 flex flex-col" data-id="element-278">
              <div className="bg-stone-100 flex items-center justify-center p-6 h-44 border-b border-stone-200" data-id="element-279">
                <img src={bono.img} alt={bono.alt} className="h-full w-auto object-contain drop-shadow-lg" data-id="element-280" />
              </div>
              <div className="p-5 flex flex-col flex-1" data-id="element-281">
                <div className="flex items-center gap-1.5 mb-2" data-id="element-282">
                  <Gift className="w-4 h-4 text-emerald-600" data-id="element-283" />
                  <span className="text-xs font-bold tracking-wider text-emerald-600 uppercase" data-id="element-284">
                    Bono #{bono.n}
                  </span>
                </div>
                <h3 className="text-base font-bold text-stone-900 leading-tight" data-id="element-285">
                  {bono.title}{' '}
                  <span className="text-stone-400 font-medium" data-id="element-286">{bono.tag}</span>
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed mt-2 mb-4 flex-1" data-id="element-287">
                  {bono.summary}
                </p>
                <div className="flex items-center gap-2 pt-3 border-t border-stone-100" data-id="element-288">
                  <span className="text-stone-400 line-through text-xs" data-id="element-289">
                    $50.000
                  </span>
                  <span className="bg-emerald-100 text-emerald-800 font-bold px-2.5 py-0.5 rounded-full text-xs" data-id="element-290">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Summary Table */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={fadeIn} className="max-w-3xl mx-auto bg-white rounded-3xl shadow-lg border border-stone-200 overflow-hidden" data-id="element-291">
          <div className="bg-stone-900 p-6 text-center" data-id="element-292">
            <h3 className="text-2xl font-bold text-white" data-id="element-293">
              Resumiendo lo que recibís hoy:
            </h3>
          </div>

          <div className="p-0" data-id="element-294">
            <table className="w-full text-left border-collapse" data-id="element-295">
              <thead data-id="element-296">
                <tr className="bg-stone-50 border-b border-stone-200" data-id="element-297">
                  <th className="p-4 md:p-6 font-bold text-stone-900 w-2/3" data-id="element-298">
                    Producto
                  </th>
                  <th className="p-4 md:p-6 font-bold text-stone-900 w-1/3 text-right" data-id="element-299">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody className="text-stone-700" data-id="element-300">
                <tr className="border-b border-stone-100" data-id="element-301">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-302">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-303" />
                    <span data-id="element-304">
                      Protocolo Anti-Inflamación (Plan 30 días + Reset 72hs)
                    </span>
                  </td>
                  <td className="p-4 md:p-6 text-right font-medium" data-id="element-305">
                    $25.000 ARS
                  </td>
                </tr>
                <tr className="border-b border-stone-100 bg-stone-50/50" data-id="element-306">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-307">
                    <Gift className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-308" />
                    <span data-id="element-309">BONO #1: Menú Anti-Inflamación Express (15 Min)</span>
                  </td>
                  <td className="p-4 md:p-6 text-right" data-id="element-310">
                    <span className="line-through text-stone-400 text-sm block md:inline md:mr-2" data-id="element-311">
                      $50.000 ARS
                    </span>
                    <span className="text-emerald-600 font-bold" data-id="element-312">GRATIS</span>
                  </td>
                </tr>
                <tr className="border-b border-stone-100" data-id="element-313">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-314">
                    <Gift className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-315" />
                    <span data-id="element-316">BONO #2: Tracker "Abdomen Calmado" (7 Días)</span>
                  </td>
                  <td className="p-4 md:p-6 text-right" data-id="element-317">
                    <span className="line-through text-stone-400 text-sm block md:inline md:mr-2" data-id="element-318">
                      $50.000 ARS
                    </span>
                    <span className="text-emerald-600 font-bold" data-id="element-319">GRATIS</span>
                  </td>
                </tr>
                <tr className="border-b border-stone-200 bg-stone-50/50" data-id="element-320">
                  <td className="p-4 md:p-6 flex items-center gap-3" data-id="element-321">
                    <Gift className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-322" />
                    <span data-id="element-323">BONO #3: Guía "Café Sin Inflamar" (En 5 Reglas)</span>
                  </td>
                  <td className="p-4 md:p-6 text-right" data-id="element-324">
                    <span className="line-through text-stone-400 text-sm block md:inline md:mr-2" data-id="element-325">
                      $50.000 ARS
                    </span>
                    <span className="text-emerald-600 font-bold" data-id="element-326">GRATIS</span>
                  </td>
                </tr>
                <tr className="border-b border-stone-200" data-id="element-327">
                  <td className="p-4 md:p-6 font-bold text-stone-900" data-id="element-328">
                    VALOR TOTAL
                  </td>
                  <td className="p-4 md:p-6 text-right font-bold text-stone-500 line-through text-lg" data-id="element-329">
                    $175.000 ARS
                  </td>
                </tr>
                <tr className="bg-emerald-50" data-id="element-330">
                  <td className="p-6 md:p-8 font-black text-emerald-900 text-xl md:text-2xl flex items-center gap-2" data-id="element-331">
                    <ArrowRight className="w-6 h-6 text-emerald-600" data-id="element-332" />
                    TU INVERSIÓN HOY
                  </td>
                  <td className="p-6 md:p-8 text-right font-black text-emerald-600 text-2xl md:text-3xl" data-id="element-333">
                    $25.000 ARS
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}